import { render } from "./header.vue?vue&type=template&id=bd6fcd6a"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/layouts/partials/header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bd6fcd6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bd6fcd6a', __exports__)) {
    console.log('reload')
    api.reload('bd6fcd6a', __exports__)
  }
  
  module.hot.accept("./header.vue?vue&type=template&id=bd6fcd6a", () => {
    console.log('re-render')
    api.rerender('bd6fcd6a', render)
  })

}


export default __exports__